<h2 mat-dialog-title>{{ 'admin_itin_to_approve.dialog.title' | translate }}</h2>
<p>{{ 'admin_itin_to_approve.dialog.descr' | translate: {itin_name: data.itin_name[data.current_lang]} }}</p>
<mat-dialog-actions align="center" class="dialog-btns">
    <button mat-button (click)="onNoClick()">{{ 'admin_itin_to_approve.dialog.cancel' | translate }}</button>
    <button mat-button (click)="unapproveItin()" cdkFocusInitial class="dialog-confirm">{{ 'admin_itin_to_approve.dialog.ok' | translate }}</button>
</mat-dialog-actions>

<app-loading-overlay [loading]="loading"></app-loading-overlay>